module.exports = __webpack_public_path__ + "img/link-pocket-desktop_en.a251a0e.jpg";